import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { UnitsProvider } from "./context/UnitsContext";
import Dashboard from "./pages/Dashboard";
import CatDetail from "./pages/CatDetail";
import Landing from "./pages/Landing";
import SignIn from "./pages/SignIn";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground">
        Loading…
      </div>
    );
  if (!user) return <Navigate to="/signin" replace />;
  return children;
}

function AnonOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return null;
  if (user) return <Navigate to="/dashboard" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <UnitsProvider>
        <BrowserRouter>
          <div className="App min-h-screen">
            <Toaster position="top-right" richColors />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route
                path="/signin"
                element={
                  <AnonOnly>
                    <SignIn />
                  </AnonOnly>
                }
              />
              <Route path="/login" element={<Navigate to="/signin" replace />} />
              <Route path="/register" element={<Navigate to="/signin" replace />} />
              <Route
                path="/dashboard"
                element={
                  <Protected>
                    <Dashboard />
                  </Protected>
                }
              />
              <Route
                path="/cat/:catId"
                element={
                  <Protected>
                    <CatDetail />
                  </Protected>
                }
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
        </BrowserRouter>
      </UnitsProvider>
    </AuthProvider>
  );
}
